import { Card, Typography, Divider } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ModifierGroupType from "./AddModifierTab/ModifierGroupType";
const AddModifier = () => {
  const navigate = useNavigate();
  const location = useLocation();
  let { id } = useParams();
  return (
    <>
      <Card>
        <div className="">
          <Typography className="text-xl font-semibold" align={"left"}>
            <LeftOutlined className="mr-2" onClick={() =>{
              sessionStorage.setItem('previousPath', location.pathname);
              navigate(-1)}
            } />
            {id ? "Edit" : "Add"} Modifier
          </Typography>
        </div>
        <Divider />
        <div className="flex gap-6">
          <div className="w-full max-w-[850px]">
            <Card>
              <ModifierGroupType />
            </Card>
          </div>
          <Card className="h-max">
            <div className="w-full max-w-[254px]">
              <h6 className="font-bold text-base mb-1">How it works</h6>
              <p className="text-[#808080]">
                Get a quick and simple guide on how to navigate and use our
                system.
              </p>
              <ol className="list-decimal text-[#808080] pl-4">
                <li>Lorem ipsum dolor sit amet consectetur. </li>
                <li>
                  Id fermentum convallis sit sodales. Tortor nam bibendum nisi
                  leo.{" "}
                </li>
                <li>Nam venenatis vel dictum elit scelerisque consectetur. </li>
              </ol>
            </div>
          </Card>
        </div>
      </Card>
    </>
  );
};
export default AddModifier;
